import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

//css
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faTrash } from "@fortawesome/free-solid-svg-icons";

//pages
import AddTaluk from "./AddTaluk.js";
import EditTaluk from "./EditTaluk.js";
import { Loading, AppPagination } from "../../components/Index.js";
import { TalukServices } from "../../../services/Taluk.js";
import AppNav from "../../../header/AppNav";
import ConfirmModal from "../../../components/ConfirmModal";
import AlertModal from "../../../components/AlertModal";

function Taluk() {
  const [addModalShow, setAddModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    cur: 1,
    max: 1,
  });

  // Modal states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [confirmModalData, setConfirmModalData] = useState({ title: '', message: '', onConfirm: null });
  const [alertModalData, setAlertModalData] = useState({ title: '', message: '', type: 'info' });

  const [taluk, setTaluk] = useState([]);

  const getTaluk = async () => {
    setLoading(true);
    try {
      const res = await TalukServices.getAllTaluks();
      setTaluk(Array.isArray(res) ? res : []);
      setLoading(false);
    } catch (error) {
      setAlertModalData({
        title: 'Error',
        message: error.message || 'Failed to load taluks',
        type: 'error'
      });
      setShowAlertModal(true);
      setLoading(false);
    }
  };

  const handleDeleteClick = (talukId, talukName) => {
    setConfirmModalData({
      title: 'Confirm Delete',
      message: `Are you sure you want to delete "${talukName}"?`,
      onConfirm: () => confirmDeleteTaluk(talukId)
    });
    setShowConfirmModal(true);
  };

  const confirmDeleteTaluk = async (id) => {
    setShowConfirmModal(false);
    setLoading(true);
    try {
      const res = await TalukServices.deleteTaluk(id);
      if (res.status === 200) {
        setAlertModalData({
          title: 'Success',
          message: res.message || 'Taluk deleted successfully!',
          type: 'success'
        });
        setShowAlertModal(true);
        getTaluk(pagination.cur);
      } else {
        setAlertModalData({
          title: 'Error',
          message: 'Error while deleting taluk',
          type: 'error'
        });
        setShowAlertModal(true);
      }
    } catch (error) {
      setAlertModalData({
        title: 'Error',
        message: error.message || 'Failed to delete taluk',
        type: 'error'
      });
      setShowAlertModal(true);
    } finally {
      setLoading(false);
    }
  };

  const changePage = (page) => {
    getTaluk(page);
  };
  useEffect(() => {
    getTaluk();
  }, []);

  return (
    <div>
      <AppNav />
      <h1 className="list-style">Taluks</h1>
      <div className="list-table-style">
        <div className="add-button">
          <Button onClick={() => setAddModalShow(true)}>Add Taluk</Button>
          <AddTaluk
  show={addModalShow}
  onHide={() => setAddModalShow(false)}
  onClose={(result) => {
    getTaluk();
    if (result) { 
      setAlertModalData({
        title: result.status === "success" ? "Success" : "Error",
        message: result.message,
        type: result.status,
      });
      setShowAlertModal(true);
    }
  }}
/>
        </div>
        <Table striped bordered hover className="professional-table">
          <thead>
            <tr>
              <th>Sl No</th>  
              <th className="list-item-align-center">Taluk</th>
              <th className="list-item-align-center">Total Asha Count</th>
              <th className="list-item-align-center">Edit</th>
              {/* <th className="list-item-align-center">Delete</th> */}
            </tr>
          </thead>
          <tbody>
            {!loading &&
              taluk.map((i, index) => (
                <tr key={i.id}>
                  <td>{index + 1}</td>
                  <td className="list-item-align-center">{i.taluk}</td>
                  <td className="list-item-align-center">{i.totalAshaCount}</td>
                  <td className="list-item-align-center">
                    <EditTaluk taluk={i} onClose={() => getTaluk()} />
                  </td>
                  {/* <td className="list-item-align-center">
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={(e) => handleDeleteClick(i.id, i.taluk)}
                      size="lg"
                      className="action-icon delete-icon"
                      title="Delete Taluk"
                    />
                  </td> */}
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      {taluk.length < 1 && (
        <h3 style={{ color: "#e77225", textAlign: "center" }}>List is empty</h3>
      )}
      {loading && <Loading />}
      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={pagination.cur}
          maxPage={pagination.max}
          changePage={changePage}
        />
      </div>

      {/* Confirm Modal */}
      <ConfirmModal
        show={showConfirmModal}
        title={confirmModalData.title}
        message={confirmModalData.message}
        onConfirm={confirmModalData.onConfirm}
        onCancel={() => setShowConfirmModal(false)}
      />

      {/* Alert Modal */}
      <AlertModal
        show={showAlertModal}
        title={alertModalData.title}
        message={alertModalData.message}
        type={alertModalData.type}
        onHide={() => setShowAlertModal(false)} 
      />
    </div>
  );
}

export default Taluk;
